import { cva } from 'class-variance-authority'

export const linkVariants = cva(
  'cursor-pointer underline decoration-1 decoration-foreground-underline underline-offset-[2.5px] transition-colors hover:decoration-inherit'
)
